import { render, staticRenderFns } from "./shopping-cart.vue?vue&type=template&id=123b1bb2&scoped=true&"
import script from "./shopping-cart.vue?vue&type=script&lang=js&"
export * from "./shopping-cart.vue?vue&type=script&lang=js&"
import style0 from "./shopping-cart.vue?vue&type=style&index=0&id=123b1bb2&lang=scss&scoped=true&"
import style1 from "./shopping-cart.vue?vue&type=style&index=1&id=123b1bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123b1bb2",
  null
  
)

export default component.exports